import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const useCongregationInvites = () => {
  const api = useApi()

  const getPublicUrl = (token, type = 'create') => {
    const path = type === 'manage_users' ? 'gestion-usuarios' : 'registro-congregacion'
    return `${window.location.origin}/${path}?token=${token}`
  }

  const getInvites = () => api.get('/api/admin/congregation-invites')

  const createInvite = (name = '', { type = 'create', congregationId = null } = {}) =>
    api.post('/api/admin/congregation-invites', { name, type, congregationId })

  const revokeInvite = (token) => api.del(`/api/admin/congregation-invites/${token}`)

  const validateInvite = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}`)
    return res.json()
  }

  const completeInvite = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}/complete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  // ── Gestión de usuarios vía enlace (type: 'manage_users') ────────────────────
  const getManagedUsers = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}/users`)
    return res.json()
  }

  const createManagedUser = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const updateManagedUser = async (token, uid, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}/users/${uid}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const deleteManagedUser = async (token, uid) => {
    const res = await fetch(`${BASE_URL}/api/public/congregation-invite/${token}/users/${uid}`, {
      method: 'DELETE',
    })
    return res.json()
  }

  return {
    getPublicUrl,
    getInvites,
    createInvite,
    revokeInvite,
    validateInvite,
    completeInvite,
    getManagedUsers,
    createManagedUser,
    updateManagedUser,
    deleteManagedUser,
  }
}
